/*
 *   File : overview.js
 *   Author : https://evoqins.com
 *   Description : overview component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React from "react";
import { SummaryCard } from "../../../Components/Cards";

export default function Overview({ dashboardData }) {
  return (
    <div className="row row-cols-lg-4 row-cols-md-3 row-cols-2 rg-24">
      {Object.entries(dashboardData).map(([key, value], i) => {
        // show only text values as cards
        if (!key.endsWith("_text")) return null;

        const baseKey = key.replace("_text", "");
        const percentageKey = `${baseKey}_percentage`;

        const title = baseKey
          .replaceAll("_", " ")
          .replace(/\b\w/g, (char) => char.toUpperCase());

        return (
          <div key={i} className="col">
            <SummaryCard
              title={title}
              description={`${dashboardData[percentageKey] ?? 0}%`}
              value={value}
              icon="upward-swiggle"
            />
          </div>
        );
      })}
    </div>
  );
}